import React from 'react';
import { Box, Paper } from '@mui/material';
import QuestionList from './QuestionList';
import QuestionTipsCard from '../QuestionTipsCard';
import QuestionsHeader from './QuestionsHeader';

import type { CampaignQuestion } from '../types';

interface QuestionsEditorViewProps {
    questions: CampaignQuestion[];
    onToggleEditMode: () => void;
}

/**
 * View-only component for displaying campaign questions.
 *
 * @param {QuestionsEditorViewProps} props
 * @returns {JSX.Element}
 */
const QuestionsEditorView: React.FC<QuestionsEditorViewProps> = (props) => {
    const { questions, onToggleEditMode } = props;

    return (
        <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', lg: 'row' } }} data-testid="campaign-questions-editor">
            <Box sx={{ flex: 1, order: { xs: 2, lg: 1 } }}>
                <Paper sx={{ p: 2, pb: 1 }}>
                    <QuestionsHeader questionsExist={questions.length > 0} onEdit={onToggleEditMode} />
                    <QuestionList questions={questions} onToggleEditMode={onToggleEditMode} />
                </Paper>
            </Box>
            <Box sx={{ width: { xs: '100%', lg: '300px' }, order: { xs: 1, lg: 2 } }}>
                <QuestionTipsCard viewMode={true} />
            </Box>
        </Box>
    );
};

export default QuestionsEditorView;
